export default {
  locale: {
    language: 'Idioma'
  }
}
